import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  getPropertyBids: makeAxiosRequest('/properties/{`id`}/bids', { method: 'get' }),
  getBidedProperties: makeAxiosRequest('/bids/auth-user-bids', { method: 'get' }),
  getBidsStatuses: makeAxiosRequest('/bids/statuses', { method: 'get' }),
  setListingWinner: makeAxiosRequest('/properties/{`id`}/selected-winner', { method: 'put' }),
};
